import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { UuIdDTO, CheckDTO, OnfidoTokenDTO } from '@app/landing-videoselfing/model/videoselfing-model';

@Injectable()
export class VideoselfingApi {
  constructor(private _http: HttpClient) {}

  postGetOnfidoDate(uuId: UuIdDTO): Observable<OnfidoTokenDTO> {
    return this._http.post<OnfidoTokenDTO>(
      environment.URL_BASE_SIGNATURE + environment.subUrlObtenerTokenVideoselfing,
      null,
      {
        params: { uuid: uuId.uuId },
      }
    );
  }

  postGetLanding(uuId: UuIdDTO) {
    return this._http.post<any>(environment.URL_BASE_SIGNATURE + environment.subUrlGetLanding, null, {
      params: { uuid: uuId.uuId },
    });
  }

  postCreateCheck(onfidoToken: OnfidoTokenDTO): Observable<CheckDTO> {
    return this._http.post<CheckDTO>(environment.URL_BASE_SIGNATURE + environment.subUrlCrearCheckVideoselfing, null, {
      params: { applicantId: onfidoToken.applicantId },
    });
  }

  postAcceptConsents(uuId: UuIdDTO): Observable<string> {
    return this._http.post<string>(
      environment.URL_BASE_SIGNATURE + environment.subUrlCrearCheckConsentimientosVideoselfing,
      null,
      {
        params: { uuid: uuId.uuId },
      }
    );
  }

  postGetHistoricalOnfido(applicantId: string, landingProcess: string): Observable<any> {
    return this._http.post<any>(environment.URL_BASE_SIGNATURE + environment.subUrlHistoricalStatusOnfido, null, {
      params: { applicantId: applicantId, landingProcess: landingProcess },
    });
  }
}
